<app-nav titulo="Tipos de cambio" descripcion="Aquí podrá ver, editar y borrar todos los datos sobre tipos de cambios registrados en la plataforma">

    <div class="exchange-rate">
        <form class="garantor-form" [formGroup]="exchangeRateFG">
            <div class="form-line">
                <mat-form-field class="garantor-form-field property-type" appearance="outline">
                    <mat-label>Código moneda base</mat-label>
                    <mat-select formControlName="codigoMonedaBase" [compareWith]="compare">
                        <mat-option *ngFor="let currency of currencyValuesAvailable" [value]="currency.codigo">
                            {{ currency.codigo }}
                        </mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="exchangeRateFG.controls['codigoMonedaBase'].hasError('required')">
                        Por favor seleccione un tipo de propiedad
                    </mat-error> -->
                </mat-form-field>
            </div>
            <div class="form-line">
                <mat-form-field class="garantor-form-field property-type" appearance="outline">
                    <mat-label>Código moneda cambio</mat-label>
                    <mat-select formControlName="codigoMonedaCambio" [compareWith]="compare">
                        <mat-option *ngFor="let currency of currencyValuesAvailable" [value]="currency.codigo">
                            {{ currency.codigo }}
                        </mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="exchangeRateFG.controls['codigoMonedaBase'].hasError('required')">
                        Por favor seleccione un tipo de propiedad
                    </mat-error> -->
                </mat-form-field>
            </div>

        </form>
        <div class="buttons-section">
            <button mat-raised-button class="garantor-button add-button" color="primary" (click)="getExchangeRate()">
                <mat-icon matPrefix class="add-button-icon">search</mat-icon>
                <span class="add-button-label">Buscar</span>
            </button>

            <button mat-raised-button class="garantor-button add-button" color="primary" (click)="openNewExchangeRateDialog()">
                <mat-icon matPrefix class="add-button-icon">add</mat-icon>
                <span class="add-button-label">Nuevo tipo de cambio</span>
            </button>
        </div>


        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="exchangeRates"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateExchangeRate($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
    </div>
</app-nav>

<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar moneda" class="edit-row-button">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Eliminar" class="view-more-row-button" >
            <mat-icon color="primary">delete</mat-icon>
        </button>
    </div>
</ng-template>
